import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect } from "react";

export default function Policies() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-background min-h-screen" data-testid="policies-page">
      <Navbar />

      <section className="pt-40 pb-4 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="font-heading text-5xl sm:text-6xl font-light tracking-tight" data-testid="policies-heading">
            Policies
          </h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 pt-10 pb-20 space-y-14" data-testid="policies-content">
        {/* Cancellation Policy */}
        <div data-testid="policy-cancellation">
          <h2 className="font-heading text-3xl sm:text-4xl font-light tracking-tight">Cancellation Policy</h2>
          <div className="mt-3 h-px w-16 bg-[#D4AF37]/60" />
          <p className="mt-7 text-zinc-300 font-light text-base sm:text-lg leading-relaxed">
            Reservations canceled at least 24 hours prior to the scheduled pickup time will receive a
            full refund. Cancellations made within 24 hours of the scheduled pickup may be subject to
            the full reservation charge, as vehicles and chauffeurs have been reserved exclusively for
            your trip.
          </p>
          <p className="mt-4 text-zinc-300 font-light text-base sm:text-lg leading-relaxed">
            We understand that travel plans can change unexpectedly. If your itinerary is affected by
            airline delays, cancellations, or other unforeseen circumstances, please contact us as soon
            as possible. We will make every reasonable effort to accommodate changes or reschedule your
            service whenever possible.
          </p>
        </div>

        {/* Waiting Time Policy */}
        <div data-testid="policy-waiting-time">
          <h2 className="font-heading text-3xl sm:text-4xl font-light tracking-tight">Waiting Time Policy</h2>
          <div className="mt-3 h-px w-16 bg-[#D4AF37]/60" />

          <div className="mt-7">
            <h3 className="text-sm tracking-label uppercase gold-text font-semibold">Airport Arrivals</h3>
            <p className="mt-3 text-zinc-300 font-light text-base sm:text-lg leading-relaxed">
              We monitor all commercial flight arrivals to help ensure a smooth pickup experience.
              Complimentary waiting time is included after your flight lands. If additional waiting
              time is required beyond the complimentary period, it will be billed at{" "}
              <span className="text-white font-medium">$35 per 15-minute increment</span>.
            </p>
          </div>

          <div className="mt-8">
            <h3 className="text-sm tracking-label uppercase gold-text font-semibold">Non-Airport Pickups</h3>
            <p className="mt-3 text-zinc-300 font-light text-base sm:text-lg leading-relaxed">
              For scheduled pickups at residences, hotels, restaurants, or other locations, 15 minutes
              of complimentary waiting time is included. Additional waiting time will be billed at{" "}
              <span className="text-white font-medium">$35 per 15-minute increment</span>.
            </p>
          </div>
        </div>

        {/* Mountain Weather Conditions */}
        <div data-testid="policy-mountain-weather">
          <h2 className="font-heading text-3xl sm:text-4xl font-light tracking-tight">Mountain Weather Conditions</h2>
          <div className="mt-3 h-px w-16 bg-[#D4AF37]/60" />
          <p className="mt-7 text-zinc-300 font-light text-base sm:text-lg leading-relaxed">
            Aspen Executive Limo proudly operates year-round in Colorado's mountain environment. During
            periods of severe mountain weather conditions, road closures, chain restrictions, or other
            circumstances beyond our control, pickup times, routes, travel times, and, in rare cases,
            rates may require adjustment. If changes become necessary, we will communicate them as
            promptly as possible before your trip.
          </p>
        </div>

        {/* After-Hours Service */}
        <div data-testid="policy-after-hours">
          <h2 className="font-heading text-3xl sm:text-4xl font-light tracking-tight">After-Hours Service</h2>
          <div className="mt-3 h-px w-16 bg-[#D4AF37]/60" />
          <p className="mt-7 text-zinc-300 font-light text-base sm:text-lg leading-relaxed">
            To accommodate transportation requests outside normal operating hours, reservations
            originating between 12:00 a.m. and 6:00 a.m. may be subject to a modest after-hours service
            fee. Any applicable fee will always be disclosed and confirmed at the time of booking. Our
            goal is to provide transparent pricing with no unexpected charges.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
